/**
 * General Settings Component Export
 *
 * @since 1.0.0
 */

export { GeneralSettings } from './component';
export type { GeneralSettingsData, GeneralSettingsProps } from './types';
